import { render, staticRenderFns } from "./ProductAndESLTags.vue?vue&type=template&id=351b6b98"
import script from "./ProductAndESLTags.vue?vue&type=script&lang=js"
export * from "./ProductAndESLTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports